import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const PeopleIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M14.4643 10.0454H15.5032C16.1918 10.0454 16.75 10.5949 16.75 11.2727C16.75 11.9505 16.1918 12.5 15.5032 12.5H14.4643M3.03571 10.0454H1.99675C1.30819 10.0454 0.75 10.5949 0.75 11.2727C0.75 11.9505 1.30819 12.5 1.99675 12.5H3.03571M11.2435 5.95455C11.2435 7.31015 10.1271 8.40909 8.75 8.40909C7.37287 8.40909 6.25649 7.31015 6.25649 5.95455C6.25649 4.59894 7.37287 3.5 8.75 3.5C10.1271 3.5 11.2435 4.59894 11.2435 5.95455ZM16.0227 6.72159C16.0227 7.56885 15.325 8.25568 14.4643 8.25568C13.6036 8.25568 12.9058 7.56885 12.9058 6.72159C12.9058 5.87434 13.6036 5.1875 14.4643 5.1875C15.325 5.1875 16.0227 5.87434 16.0227 6.72159ZM4.59414 6.72159C4.59414 7.56885 3.89641 8.25568 3.0357 8.25568C2.175 8.25568 1.47726 7.56885 1.47726 6.72159C1.47726 5.87434 2.175 5.1875 3.0357 5.1875C3.89641 5.1875 4.59414 5.87434 4.59414 6.72159ZM4.75 11.2727C4.75 11.9505 5.29947 12.5 5.97727 12.5H11.5227C12.2005 12.5 12.75 11.9505 12.75 11.2727C12.75 10.5949 12.2005 10.0455 11.5227 10.0455H5.97727C5.29947 10.0455 4.75 10.5949 4.75 11.2727Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

PeopleIcon.displayName = 'PeopleIcon';
